import React from "react";
import { CKEditor } from "@ckeditor/ckeditor5-react";

import {
  Alignment,
  Autoformat,
  AutoImage,
  AutoLink,
  Base64UploadAdapter,
  BlockQuote,
  Bold,
  Image as CKImage,
  Link as CKLink,
  ClassicEditor,
  CloudServices,
  Code,
  CodeBlock,
  FindAndReplace,
  Font,
  GeneralHtmlSupport,
  Heading,
  HorizontalLine,
  HtmlEmbed,
  ImageCaption,
  ImageInsert,
  ImageResize,
  ImageStyle,
  ImageToolbar,
  ImageUpload,
  Indent,
  IndentBlock,
  Italic,
  LinkImage,
  List,
  ListProperties,
  MediaEmbed,
  Mention,
  PageBreak,
  Paragraph,
  PasteFromOffice,
  PictureEditing,
  RemoveFormat,
  SelectAll,
  ShowBlocks,
  SourceEditing,
  Strikethrough,
  Style,
  Subscript,
  Superscript,
  Table,
  TableCaption,
  TableCellProperties,
  TableColumnResize,
  TableProperties,
  TableToolbar,
  TextPartLanguage,
  TextTransformation,
  TodoList,
  Underline
} from "ckeditor5";

import "ckeditor5/ckeditor5.css";

const HTMLEditor = ({ onBlur, value = "", disabled = false, editorReady, onChange }) => {
  return (
    <CKEditor
      editor={ClassicEditor}
      data={value}
      disabled={disabled}
      onReady={editorReady}
      onBlur={onBlur}
      onChange={(event, editor) => {
        const data = editor.getData();

        if (onChange) {
          onChange(data);
        }
      }}
      config={{
        table: {
          tableToolbar: [
            "table",
            "tableColumn",
            "tableRow",
            "tableCell",
            "mergeTableCells",
            "tableCellMergeSplit"
          ]
        },

        image: {
          toolbar: [
            "imageStyle:inline",
            "imageStyle:alignLeft",
            "imageStyle:alignCenter",
            "imageStyle:alignRight",
            "|",
            "toggleImageCaption",
            "imageTextAlternative",
            "|",
            "resizeImage"
          ],

          resizeOptions: [
            {
              name: "resizeImage:original",
              label: "Original",
              value: null
            },
            {
              name: "resizeImage:25",
              label: "25%",
              value: "25"
            },
            {
              name: "resizeImage:50",
              label: "50%",
              value: "50"
            },
            {
              name: "resizeImage:75",
              label: "75%",
              value: "75"
            }
          ],

          resizeUnit: "%"
        },

        toolbar: {
          shouldNotGroupWhenFull: true,
          items: [
            "undo",
            "redo",
            "|",
            "bold",
            "italic",
            "underline",
            "strikethrough",
            "superscript",
            "subscript",

            "fontSize",
            "fontFamily",
            "fontColor",
            "fontBackgroundColor",

            "|",
            "heading",
            "|",

            "removeFormat",
            "|",

            "alignment",
            "|",

            "bulletedList",
            "numberedList",
            "todoList",

            "|",
            "outdent",
            "indent",

            "|",

            "findAndReplace",
            "selectAll",

            "|",

            "insertImage",
            "link",
            "insertTable",
            "blockQuote",
            "mediaEmbed",
            "codeBlock",
            "htmlEmbed",
            "pageBreak",
            "horizontalLine",

            "|",

            "sourceEditing",
            "showBlocks"
          ]
        },

        plugins: [
          Alignment,
          Autoformat,
          AutoImage,
          AutoLink,
          Base64UploadAdapter,
          BlockQuote,
          Bold,
          CloudServices,
          Code,
          CodeBlock,
          FindAndReplace,
          Font,
          GeneralHtmlSupport,
          Heading,
          HorizontalLine,
          HtmlEmbed,
          CKImage,
          ImageCaption,
          ImageInsert,
          ImageResize,
          ImageStyle,
          ImageToolbar,
          ImageUpload,
          Indent,
          IndentBlock,
          Italic,
          CKLink,
          LinkImage,
          List,
          ListProperties,
          MediaEmbed,
          Mention,
          PageBreak,
          Paragraph,
          PasteFromOffice,
          PictureEditing,
          RemoveFormat,
          SelectAll,
          ShowBlocks,
          SourceEditing,
          Strikethrough,
          Style,
          Subscript,
          Superscript,
          Table,
          TableCaption,
          TableCellProperties,
          TableColumnResize,
          TableProperties,
          TableToolbar,
          TextPartLanguage,
          TextTransformation,
          TodoList,
          Underline
        ],
        htmlSupport: {
          allow: [
            {
              name: /.*/,
              attributes: true,
              classes: true,
              styles: true
            }
          ]
        }
      }}
    />
  );
};

export default HTMLEditor;
